module.exports = __webpack_public_path__ + "resources/images/contract-76fb8d31bd85c31149b7b2028b64421f-cache.jpg";